import React from 'react';
import {
    FaBuilding, FaIndustry, FaHome, FaUniversity,
    FaShoppingCart, FaUtensils, FaLandmark, FaCity, FaGraduationCap
} from 'react-icons/fa';

const Industries = () => {
    const industries = [
        { icon: <FaBuilding size={32} />, name: 'Commercial Construction' },
        { icon: <FaIndustry size={32} />, name: 'Industrial & Manufacturing' },
        { icon: <FaHome size={32} />, name: 'Residential' },
        { icon: <FaUniversity size={32} />, name: 'Financial Institutions' },
        { icon: <FaShoppingCart size={32} />, name: 'Retail' },
        { icon: <FaUtensils size={32} />, name: 'Restaurants' },
        { icon: <FaLandmark size={32} />, name: 'Government Institution' },
        { icon: <FaCity size={32} />, name: 'Municipalities' },
        { icon: <FaGraduationCap size={32} />, name: 'Education' }
    ];

    return (
        <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white relative overflow-hidden">
            {/* Background decorations */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl opacity-10"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl opacity-10"></div>
            </div>

            <div className="max-w-7xl mx-auto relative z-10">
                {/* Header */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-4 px-4 py-2 bg-white/10 border border-white/20 rounded-full backdrop-blur-sm">
                        <span className="text-cyan-300 text-sm font-bold tracking-wider">EXPERTISE</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">
                        Industries We <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Cover</span>
                    </h2>
                    <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                        Serving diverse sectors with specialized telecommunications solutions
                    </p>
                </div>

                {/* Industries Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
                    {industries.map((industry, index) => (
                        <div
                            key={index}
                            className="group relative"
                        >
                            <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 hover:bg-white/10 hover:border-cyan-400/30 transition-all duration-500 hover:-translate-y-2 cursor-pointer">
                                {/* Icon */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-cyan-400/20 to-blue-500/20 flex items-center justify-center text-cyan-400 group-hover:text-white group-hover:bg-gradient-to-br group-hover:from-cyan-500 group-hover:to-blue-500 transition-all duration-300">
                                        {industry.icon}
                                    </div>
                                </div>

                                {/* Name */}
                                <h3 className="text-center text-sm md:text-base font-semibold text-white/90 group-hover:text-white">
                                    {industry.name}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Industries;
